import React, { Component } from "react";
import CustomButton from "../components/CustomButton";
import { Modal, Form } from "react-bootstrap";
import Loading from "../components/Loading";
import { toast } from "react-toastify";
import {
  BaseUrl,
  Authorization,
  BaseUrlAssets,
  BaseUrlPublic,
} from "../static.js";

export default class UserLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userNameErrorText: "",
      userNameValue: "",
      passwordErrorText: "",
      passwordValue: "",
      logo: "",
      resName: "",
      dataLoading: true,
      notFound: true,
    };

    this.textHandleChange = this.textHandleChange.bind(this);

    this.userNameInput = React.createRef();
  }

  componentDidMount() {
    if (Authorization().token) {
      let data = { businessCode: this.props.match.params.id };
      data = Object.assign(data, Authorization());
      console.log(data);
      fetch(BaseUrl + "checkToken", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.props.history.push(
              "/Restaurants/" + this.props.match.params.id
            );
          } else {
            this.findBusinessWithCode();
          }
        })
        .catch((err) => {
          this.findBusinessWithCode();
        });
    } else {
      this.findBusinessWithCode();
    }
  }

  findBusinessWithCode() {
    let data = {
      businessCode: this.props.match.params.id,
    };

    fetch(BaseUrlPublic + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        this.setState({ dataLoading: false });
        if (result.status === 200) {
          let name = "";
          result.info.forEach((element) => {
            if (element.languageId === result.result[0].defaultLanguage) {
              name = element.name;
            }
          });
          this.setState(
            {
              notFound: false,
              logo: BaseUrlAssets + result.result[0].logo,
              resName: name,
            },
            () => {
              this.userNameInput.current.focus();
            }
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onLogin() {
    if (!this.state.userNameValue) {
      this.setState({ userNameErrorText: "لطفاً نام کاربری را وارد کنید" });
      return;
    } else this.setState({ userNameErrorText: "" });

    if (!this.state.passwordValue) {
      this.setState({ passwordErrorText: "لطفاً کلمه عبور را وارد کنید" });
      return;
    } else this.setState({ passwordErrorText: "" });

    let data = {
      userName: this.state.userNameValue,
      password: this.state.passwordValue,
      businessCode: this.props.match.params.id,
    };

    console.log(data);

    fetch(BaseUrl + "login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          sessionStorage.clear();
          localStorage.clear();
          localStorage.setItem("userName", this.state.userNameValue);
          localStorage.setItem("tokenn", result.token);
          localStorage.setItem("code", this.props.match.params.id);
          this.props.history.push("/Restaurants/" + this.props.match.params.id);
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.onLogin();
    }
  }

  render() {
    if (!this.state.dataLoading) {
      if (this.state.notFound) {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100vh",
            }}
          >
            <div
              style={{
                margin: "0px 10px",
                borderRadius: "8px",
                border: "2px solid var(--brown1)",
                padding: "20px",
              }}
            >
              آدرسی که بدنبال آن هستید اشتباه است و رستورانی با این آدرس ثبت
              نشده
            </div>
          </div>
        );
      } else {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100vh",
            }}
          >
            <div
              style={{
                width: "90%",
                maxWidth: "350px",
                borderRadius: "8px",
                border: "2px solid var(--brown1)",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
              }}
            >
              <div
                style={{
                  borderRadius: "50%",
                  border: "4px solid var(--brown1)",
                  overflow: "hidden",
                  width: "120px",
                  height: "120px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={this.state.logo}
                  alt=""
                  style={{
                    width: "120px",
                    objectFit: "contain",
                  }}
                />
              </div>

              <h6 style={{ margin: "15px 0px", color: "var(--brown1)" }}>
                {this.state.resName}
              </h6>
              <div
                style={{
                  minHeight: "1px",
                  backgroundColor: "var(--brown1)",
                  width: "100%",
                  marginBottom: "20px",
                }}
              />

              <Form.Control
                maxLength="50"
                className={
                  this.state.userNameErrorText !== ""
                    ? "inputStyleForm inputError textAlignCenter"
                    : "inputStyleForm textAlignCenter"
                }
                style={{ marginBottom: "15px" }}
                placeholder="نام کاربری"
                type="text"
                name="userNameValue"
                onChange={this.textHandleChange.bind(this)}
                value={this.state.userNameValue}
                ref={this.userNameInput}
                onKeyPress={this.handleKeyPress.bind(this)}
              />

              <Form.Control
                maxLength="50"
                className={
                  this.state.passwordErrorText !== ""
                    ? "inputStyleForm inputError textAlignCenter"
                    : "inputStyleForm textAlignCenter"
                }
                style={{ marginBottom: "15px" }}
                placeholder="کلمه عبور"
                type="password"
                name="passwordValue"
                onChange={this.textHandleChange.bind(this)}
                value={this.state.passwordValue}
                onKeyPress={this.handleKeyPress.bind(this)}
              />

              <CustomButton
                title="ورود"
                imgHeight={20}
                imgWidth={25}
                minHeight="35px"
                onClick={this.onLogin.bind(this)}
              />
            </div>
          </div>
        );
      }
    } else {
      return <Loading />;
    }
  }
}
